import React from 'react'
import { Link as GLink } from 'gatsby'
import { Link, useThemeUI, get } from 'theme-ui'
import AvatarSimple from '@components/AvatarSimple'
import rv from '@components/utils/buildResponsiveVariant'
import {
  getSelectedArticleAuthors,
  attachThumbnail
} from '../../../../themes/gatsby-theme-flexiblog-personal/src/helpers/nr-authors.helper'

const CardFooterAuthorAvatar = ({ variant, omitAuthor, title }) => {
  const context = useThemeUI()

  if (omitAuthor) return null

  const responsiveVariant = rv(variant, 'authorPhoto')

  const visibility = responsiveVariant.reduce(
    (mobileVisibility, variant) =>
      mobileVisibility === false &&
      get(context.theme, variant, {}).display === 'none'
        ? false
        : true,
    false
  )

  let authors = getSelectedArticleAuthors(title)
  attachThumbnail(authors)
  let temp = [...authors]
  let str = ''
  temp.forEach(el => (str += el.name + ' '))

  return (
    <>
      {visibility &&
        authors.map(item => {
          if (item?.thumbnail)
            return (
              <>
                <Link
                  as={GLink}
                  to={`/author/${item.slug}/`}
                  aria-label={item.name}
                  sx={{ variant: responsiveVariant }}
                >
                  <AvatarSimple
                    avatar={item.thumbnail}
                    alt={item.name}
                    size='small'
                  />
                </Link>
              </>
            )
        })}
    </>
  )
}

export default CardFooterAuthorAvatar
